/* istanbul ignore file */
import * as _ from 'lodash';
import { getCookie } from '../common/utils';
import { CIG_SSO } from '../common/constants';

export class Auth {
    constructor(){
        this.getAccessToken = this.getAccessToken.bind(this);
        this.done = this.done.bind(this);
    }

    done(err, data) {
        if (err) throw err;
        return data;
    }

    getAccessToken() {
        return getCookie('', CIG_SSO.cookieJWT);
    }

    getTokenPayload(token) {
        if (!_.isEmpty(token)) {
            try {
                const tokenPart = _.split(token, '.');
                const jsonStr = window.atob(tokenPart[1]);
                return JSON.parse(jsonStr);
            }
            catch (e) {
                window.CIG_LOG.debug('Gateway: Failed to decode access token payload.');
            }
        }
        return {};
    }
}

export default Auth;